import { message } from "antd";
import { useLibraryCreativesContext } from "../../../../core/components/creatives/library/useLibraryCreativesContext";

export const useDeleteMedias = () => {
  const { updateManyMedias } = useLibraryCreativesContext() || {};

  const handleDeleteMedias = async ids => {
    try {
      message.loading("Deleting...", 0);
      await updateManyMedias({
        variables: {
          ids,
          data: { flag: false },
        },
      });
      message.destroy();
      message.success(`${ids.length} creative${ids.length === 1 ? '' : 's'} successfully deleted.`);
    } catch (err) {
      message.destroy();
      message.error("Failed to delete creatives.");
    }
  };

  return { handleDeleteMedias };
};
